module.exports = __webpack_public_path__ + "static/img/icon_information.5a975193.png";